import { useCallback, useEffect, useRef, useState } from 'react';

/** Carência para o ponteiro atravessar o vão entre o ícone e o painel. */
const CLOSE_DELAY_MS = 150;

/**
 * Abre no hover e fecha com carência: o painel é portalado, então sair do ícone
 * e entrar nele são dois eventos separados — fechar na hora tornaria o painel
 * inalcançável.
 */
export const useHoverFlyout = () => {
    const [isOpen, setIsOpen] = useState(false);
    const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

    const cancelClose = useCallback(() => {
        if (timer.current) {
            clearTimeout(timer.current);
            timer.current = undefined;
        }
    }, []);

    const open = useCallback(() => {
        cancelClose();
        setIsOpen(true);
    }, [cancelClose]);

    const close = useCallback(() => {
        cancelClose();
        setIsOpen(false);
    }, [cancelClose]);

    const scheduleClose = useCallback(() => {
        cancelClose();
        timer.current = setTimeout(() => setIsOpen(false), CLOSE_DELAY_MS);
    }, [cancelClose]);

    useEffect(() => cancelClose, [cancelClose]);

    return { isOpen, open, close, scheduleClose, cancelClose };
};
